import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import cx from 'classnames';

export const BankScrapingIframe = ({
  iFrameUrl, isLoaded, onLoad, onError,
}) => (
  <iframe
    className={cx('bank-scraping', { 'bank-scraping--loading': !isLoaded })}
    src={iFrameUrl}
    onLoad={onLoad}
    onError={onError}
  >
    <FormattedMessage id="error.iframe_support" />
  </iframe>
);

BankScrapingIframe.propTypes = {
  iFrameUrl: PropTypes.string,
  isLoaded: PropTypes.bool,
  onLoad: PropTypes.func,
  onError: PropTypes.func,
};
